import { Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet} from '@angular/router';
import { NgxLoadingModule } from 'ngx-loading';
import { Subscription } from 'rxjs';
import { LoaderService } from '@coreServices';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, NgxLoadingModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class AppComponent {

  isLoading: boolean = false;
  private loadingSubscription!: Subscription;

  constructor(
    public loaderService: LoaderService,
  ) {
  }

  ngOnInit() {
    this.loadingSubscription = this.loaderService.loading$.subscribe((isLoading) => {
      setTimeout(() => {
        this.isLoading = isLoading;
      }, 0);
    });
  }

  ngOnDestroy() {
    this.loadingSubscription?.unsubscribe();
  }

}
